import { lazy } from 'react'

// Billing Admin
export const BillingAdminPage = lazy(() => import('@features/billing-admin/pages/BillingAdminPage'))
export const BillingPayoutDetailPage = lazy(() =>
  import('@features/billing-admin/pages/BillingPayoutDetailPage')
)
export const BillingReserveDetailPage = lazy(() =>
  import('@features/billing-admin/pages/BillingReserveDetailPage')
)
export const TariffDetailPage = lazy(() =>
  import('@features/billing-admin/pages/TariffDetailPage')
)
export const FeeDetailPage = lazy(() =>
  import('@features/billing-admin/pages/FeeDetailPage')
)
export const FxRateDetailPage = lazy(() =>
  import('@features/billing-admin/pages/FxRateDetailPage')
)

// Velocity
export const VelocityPage = lazy(() =>
  import('@features/velocity/pages/VelocityPage')
)
export const VelocityListPage = lazy(() =>
  import('@features/velocity/pages/VelocityListPage')
)
export const VelocityDetailPage = lazy(() =>
  import('@features/velocity/pages/VelocityDetailPage')
)
export const VelocityLimitDetailPage = lazy(() =>
  import('@features/velocity/pages/VelocityLimitDetailPage')
)

// Payout schedule wizard
export const PayoutCreateWizardPage = lazy(() =>
  import('@features/payout-schedules/pages/PayoutCreateWizardPage')
)
export const PayoutEditWizardPage = lazy(() =>
  import('@features/payout-schedules/pages/PayoutEditWizardPage')
)
export const PayoutDuplicateWizardPage = lazy(() =>
  import('@features/payout-schedules/pages/PayoutDuplicateWizardPage')
)
export const PayoutVariationWizardPage = lazy(() =>
  import('@features/payout-schedules/pages/PayoutVariationWizardPage')
)
export const PayoutVersionHistoryPage = lazy(() =>
  import('@features/payout-schedules/pages/PayoutVersionHistoryPage')
)
export const PayoutEstimatorPage = lazy(() =>
  import('@features/payout-schedules/pages/PayoutEstimatorPage')
)

// FX schedule wizard
export const FxCreateWizardPage = lazy(() =>
  import('@features/fx-schedules/pages/FxCreateWizardPage')
)
export const FxEditWizardPage = lazy(() => import('@features/fx-schedules/pages/FxEditWizardPage'))
export const FxDuplicateWizardPage = lazy(() =>
  import('@features/fx-schedules/pages/FxDuplicateWizardPage')
)
export const FxVariationWizardPage = lazy(() =>
  import('@features/fx-schedules/pages/FxVariationWizardPage')
)

// Fee schedule wizard
export const FeeCreateWizardPage = lazy(() =>
  import('@features/fee-schedules/pages/FeeCreateWizardPage')
)
export const FeeEditWizardPage = lazy(() =>
  import('@features/fee-schedules/pages/FeeEditWizardPage')
)
export const FeeDuplicateWizardPage = lazy(() =>
  import('@features/fee-schedules/pages/FeeDuplicateWizardPage')
)
export const FeeVariationWizardPage = lazy(() =>
  import('@features/fee-schedules/pages/FeeVariationWizardPage')
)
export const FeeCalculatorPage = lazy(() =>
  import('@features/fee-schedules/pages/FeeCalculatorPage')
)
export const FeeVersionHistoryPage = lazy(() =>
  import('@features/fee-schedules/pages/FeeVersionHistoryPage')
)

// Tariff schedule wizard
export const TariffCreateWizardPage = lazy(() =>
  import('@features/tariff-schedules/pages/TariffCreateWizardPage')
)
export const TariffEditWizardPage = lazy(() =>
  import('@features/tariff-schedules/pages/TariffEditWizardPage')
)
export const TariffDuplicateWizardPage = lazy(() =>
  import('@features/tariff-schedules/pages/TariffDuplicateWizardPage')
)
export const TariffVariationWizardPage = lazy(() =>
  import('@features/tariff-schedules/pages/TariffVariationWizardPage')
)
export const TariffVersionHistoryPage = lazy(() =>
  import('@features/tariff-schedules/pages/TariffVersionHistoryPage')
)

// Reserves wizard
export const ReserveCreateWizardPage = lazy(() =>
  import('@features/reserves/pages/ReserveCreateWizardPage')
)
export const ReserveEditWizardPage = lazy(() =>
  import('@features/reserves/pages/ReserveEditWizardPage')
)
export const ReserveDuplicateWizardPage = lazy(() =>
  import('@features/reserves/pages/ReserveDuplicateWizardPage')
)
export const ReserveVariationWizardPage = lazy(() =>
  import('@features/reserves/pages/ReserveVariationWizardPage')
)
export const ReserveVersionHistoryPage = lazy(() =>
  import('@features/reserves/pages/ReserveVersionHistoryPage')
)
export const ReserveImpactCalculatorPage = lazy(() =>
  import('@features/reserves/pages/ReserveImpactCalculatorPage')
)
